import React from 'react'
import { Col, Row } from 'react-bootstrap';
import { useState } from 'react';
import GenericAttachmentGrid from '../Grid/GenericAttachmentGrid';
import attachmentService from '../../../services/Shared/attachment.service';
import { Form, InputPicker, Uploader } from 'rsuite';
import { useEffect } from 'react';
import Swal from 'sweetalert2';
import LoadingSpinner from '../GenericComponents/LoadingSpinner';
import { sort_by } from '../HelperFunctions';

function BoardAttachmentGrid(props) {
    const [attachmentTypes, setAttachmentTypes] = useState([]);
    const [hasLoaded, setHasLoaded] = useState();

    useEffect(() => {
        let isComity = props.isApp ? (props.credentialOrAppTypeId == 3 || props.credentialOrAppTypeId == 5) : false;
        let isExam = props.isApp ? (props.credentialOrAppTypeId == 4 || props.credentialOrAppTypeId == 6) : false;
        attachmentService.getBoardReviewDocTypes(props.attachmentParentTypeId, props.isApp ? null : props.credentialOrAppTypeId, props.isApp ? 10 : 11, isComity, isExam, props.attachmentSection).then((data) => {
            setAttachmentTypes(data);
        })
    }, [])
    useEffect(() => { refreshGrid(); }
        , [attachmentTypes])
    useEffect(() => { refreshGrid(); }
        , [props.refreshAttachments])
    const [formData, updateFormData] = useState({
        files: [],
        filesForDisplay: [],
        loading: false,
    });

    const refreshGrid = () => {
        setHasLoaded(false)
        updateFormData({
            ...formData,
            loading: true,
        })

        attachmentService.getFiles(props.attachmentSectionId, props.attachmentParentTypeId, null).then((data) => {
            var attachmentTypeIds = attachmentTypes.map((attachmentType, index) => {
                return attachmentType.value;
            })
            var tempData = [];
            var sortedData = data?.data.sort(sort_by('uploadDate', true));
            tempData = sortedData?.filter(tempData => attachmentTypeIds.includes(tempData.documentTypeId)).map((tempData, index) => {
                return {
                    id: tempData.id,
                    timestamp: new Date(tempData.uploadDate).toLocaleDateString(),
                    file: tempData.fileName,
                    attachmentType: tempData.documentType,
                    fileLink: '',
                    hideDelete: true
                };
            })
            updateFormData({
                filesForDisplay: tempData,
                files: [],
                loading: false,
            })
            setHasLoaded(true)
        })
    }

    return <>
        {hasLoaded ?
            formData.filesForDisplay.length > 0 ?
                <>
                    <Row>
                        <Col sm="12">
                            <h4>Documents</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12">
                            <div>
                                <br />
                                <Form.Control
                                    accepter={GenericAttachmentGrid}
                                    data={formData.filesForDisplay}
                                    tStyle="table-bordered"
                                    name="filesForDisplay" />
                            </div>
                        </Col>
                    </Row>
                </>
                : <Row>
                    <Col sm="12">
                        <h4>No Documents Attached</h4>
                    </Col>
                </Row>
            :
            <LoadingSpinner />
        }
    </>;
}
export default BoardAttachmentGrid;